<div class="page-title animatedBackground">
    <div class="container">
        <h3>Contact</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Contact</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="contact-text">
                    <h3>Get in Touch</h3>
                    <p>We’d love to hear from you! Whether you have questions, collaboration ideas, or want to learn
                        more about our sports and media initiatives, reach out to us.</p>
                    <ul class="social-links">
                        <li><a href="https://www.facebook.com/people/A-M-Media-and-Sports/61575779366522/"
                                target="_blank"><i class="icofont-facebook"></i></a></li>
                        <li><a href="https://x.com/ammediasports"><i class="icofont-x"></i></a></li>
                        <li><a href="https://www.instagram.com/ammediasports/"><i class="icofont-instagram"></i></a>
                        </li>
                        <li><a href="https://www.linkedin.com/company/am-media-and-sports-pvt-ltd"><i
                                    class="icofont-linkedin"></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <form id="contactForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="Name">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="email" class="form-control" placeholder="Email">
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="Subject">
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <textarea name="message" class="form-control" id="message" cols="30" rows="4"
                                    placeholder="Your Message"></textarea>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <button type="submit" class="btn btn-primary me-md-3">Send</button>
                            <button type="submit" class="pl-2 btn btn-danger">Clear</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>